export default __webpack_public_path__ + "media/images/images/carousel/28-70511d10e08bb8b1f0cbd25652c6431e.jpg";